export const tableOnlyEntityAction = {
  collapsed: true as const,
  includeInForm: false as const,
};
